module.exports = __webpack_public_path__ + "220d3d998596dd0cc5e084ef7ff0ad3c.png";